div.rangeRadioGroup {
	position: relative;
	flex-wrap: nowrap;
	justify-content: space-between;
	gap: 10px;
}

.rangeRadioBarBackground {
	position: absolute;
	top: 13px;
	height: 8px;
	left: 12.5%;
	right: 12.5%;
	background: #f3f3f3;
}

.rangeRadioBarForeground {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	background: #0b6f85;
}

label.rangeRadioOption {
	flex: 1;
	gap: 1px;
	flex-direction: column;
	text-align: center;
	font-size: 14px;
	font-weight: 600;
	color: black;
	cursor: pointer;
	margin: 0;
}

.rangeRadioHeader {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 12px;
	color: #737373;
}

.rangeRadioHeaderWrapper {
	display: flex;
	flex-direction: column;
	align-items: stretch;
	font-size: 12px;
	font-weight: 400;
	color: #7c7c7c;
	margin-top: 16px;
	margin-bottom: 11px;
}
